<app-view-title Title="" [showBack]="true" [overlay]="true"></app-view-title>
<location-map #map mode="Pickup" [locations]="locations" [(selectedLocation)]="selectedLocation" (locationConfirmed)="selectLocation()"></location-map>

<div class="bottom-nav">
  <h2>{{'Intellitrailer_ReturnLocation_lblSelectPickupLocation' | translate: 'Select pickup location'}}</h2>
</div>

